(function () {
  'use strict';

  if (window.__ANATOMY_FUNNEL_EXPERIMENTS__) return;
  window.__ANATOMY_FUNNEL_EXPERIMENTS__ = true;

  var configs = {
    'anatomy-protocol-choice-v1': {
      qaParam: 'an_protocol_choice',
      variants: ['control', 'treatment'],
      eligiblePaths: [
        '/pages/heat-damaged-hair-reconstruction',
        '/pages/bleach-damage-reconstruction',
        '/pages/click-chemistry-for-hair',
        '/pages/not-coating-vs-reconstruction'
      ]
    },
    'anatomy-checkout-path-v1': {
      qaParam: 'an_checkout_path',
      variants: ['drawer', 'direct'],
      eligiblePaths: [
        '/pages/heat-damaged-hair-reconstruction',
        '/pages/bleach-damage-reconstruction',
        '/pages/click-chemistry-for-hair',
        '/pages/not-coating-vs-reconstruction'
      ]
    }
  };
  var states = {};
  var exposureKey = 'anatomy_funnel_flag_exposures_v1';
  var assignmentKey = 'anatomy_funnel_flag_assignments_v1';
  var exposuresBound = false;

  function readSession(key) {
    try {
      return JSON.parse(window.sessionStorage.getItem(key) || '{}') || {};
    }
    catch (error) {
      return {};
    }
  }

  function writeSession(key, value) {
    try {
      window.sessionStorage.setItem(key, JSON.stringify(value));
    }
    catch (error) {}
  }

  function forcedVariant(config) {
    try {
      return new URLSearchParams(window.location.search).get(config.qaParam) || '';
    }
    catch (error) {
      return '';
    }
  }

  function eligible(config) {
    return config.eligiblePaths.indexOf(window.location.pathname) !== -1;
  }

  function capture(name, props) {
    try {
      if (window.posthog && typeof window.posthog.capture === 'function') {
        window.posthog.capture(name, props);
        return true;
      }
    }
    catch (error) {}
    return false;
  }

  function experimentProps(key, state) {
    return {
      schema_version: 'funnel_context_v2',
      experiment_id: key,
      experiment_version: '2026-07-26.1',
      experiment_phase: state.forced ? 'qa_forced' : 'posthog_feature_flag',
      experiment_variant: state.variant,
      experiment_source: 'posthog_feature_flag',
      experiment_is_qa_forced: !!state.forced,
      experiment_analysis_eligible: !state.forced,
      experiment_page_group: window.location.pathname,
      feature_flag_key: key
    };
  }

  function applyState(key, variant, forced) {
    var config = configs[key];
    if (!config || config.variants.indexOf(variant) === -1) return;
    var state = { variant: variant, forced: !!forced, appliedAt: new Date().toISOString() };
    states[key] = state;

    config.variants.forEach(function (candidate) {
      document.documentElement.classList.remove('an-ff-' + key + '-' + candidate);
    });
    document.documentElement.classList.add('an-ff-' + key + '-' + variant);
    document.documentElement.setAttribute('data-an-ff-' + key, variant);

    var seen = readSession(assignmentKey);
    var signature = key + ':' + variant + ':' + (forced ? 'qa' : 'live');
    if (!seen[signature] && capture('an_experiment_assigned', experimentProps(key, state))) {
      seen[signature] = state.appliedAt;
      writeSession(assignmentKey, seen);
    }

    window.dispatchEvent(new CustomEvent('anatomy:experiment-applied', {
      detail: { experimentId: key, variant: variant, forced: !!forced }
    }));
  }

  function evaluateFlags() {
    if (!window.posthog || typeof window.posthog.getFeatureFlag !== 'function') return false;
    Object.keys(configs).forEach(function (key) {
      var config = configs[key];
      if (!eligible(config)) return;
      var forced = forcedVariant(config);
      if (config.variants.indexOf(forced) !== -1) {
        applyState(key, forced, true);
        return;
      }
      var value = window.posthog.getFeatureFlag(key);
      if (config.variants.indexOf(value) !== -1) applyState(key, value, false);
    });
    return true;
  }

  function bindExposures() {
    if (exposuresBound || !('IntersectionObserver' in window)) return;
    exposuresBound = true;
    var seen = readSession(exposureKey);
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || entry.intersectionRatio < 0.45) return;
        var key = entry.target.getAttribute('data-an-feature-flag-surface') || '';
        var state = states[key];
        if (!state) return;
        var signature = key + ':' + state.variant;
        if (!seen[signature]) {
          capture('an_experiment_exposed', Object.assign(experimentProps(key, state), {
            experiment_exposed_at: new Date().toISOString()
          }));
          seen[signature] = new Date().toISOString();
          writeSession(exposureKey, seen);
        }
        observer.unobserve(entry.target);
      });
    }, { threshold: [0.45] });
    document.querySelectorAll('[data-an-feature-flag-surface]').forEach(function (surface) {
      observer.observe(surface);
    });
  }

  function initialize() {
    Object.keys(configs).forEach(function (key) {
      var config = configs[key];
      if (!eligible(config)) return;
      var forced = forcedVariant(config);
      if (config.variants.indexOf(forced) !== -1) applyState(key, forced, true);
    });
    bindExposures();
    if (window.posthog && typeof window.posthog.onFeatureFlags === 'function') {
      window.posthog.onFeatureFlags(evaluateFlags);
      evaluateFlags();
      return true;
    }
    return false;
  }

  window.AnatomyFunnelExperiments = {
    getVariant: function (key) {
      return states[key] ? states[key].variant : '';
    },
    checkoutModeForForm: function (form) {
      if (!form || !form.getAttribute) return '';
      var key = form.getAttribute('data-an-checkout-experiment') || '';
      var variant = states[key] ? states[key].variant : '';
      if (variant === 'drawer' || variant === 'direct') return variant;
      return form.getAttribute('data-an-checkout-default') || '';
    },
    states: states,
    evaluate: evaluateFlags
  };

  if (!initialize()) {
    var poll = window.setInterval(function () {
      if (initialize()) window.clearInterval(poll);
    }, 200);
    window.setTimeout(function () { window.clearInterval(poll); }, 10000);
  }
})();
